<template>
  <bk-page class="receiveGiftCard" pageType="navRoot" :navBarInfo="navBarInfo" :loading="!isReady">
    <bk-view class="page-container" v-if="isReady">

      <bk-view class="view-container view-result" v-if="errorLink">
        <bk-image :src="$bk_getImageUrl('Def_Icon_E_Giftcard_Claim_Fail.png')"/>
        <bk-title>Invalid link</bk-title>

        <bk-button class="view-gotIt" lang-code="receiveGiftCard_got" @click="handleGotIt"></bk-button>
      </bk-view>

      <bk-view class="view-container view-result" v-else-if="status==='SUCCESS'">
        <bk-image :src="$bk_getImageUrl('Def_Icon_E_Giftcard_Claim_Success.png')"/>
        <bk-title lang-code="receiveGiftCard_claim_success"></bk-title>
        <bk-view class="view-tips">
          <bk-lang code="receiveGiftCard_claim_success_tip"/>
        </bk-view>
        <bk-button class="view-gotIt" lang-code="receiveGiftCard_got" @click="handleGotIt" />
      </bk-view>

      <bk-view class="view-container view-result" v-else-if="status==='EXPIRED'">
        <bk-image :src="$bk_getImageUrl('Def_Icon_E_Giftcard_Claim_Fail.png')"/>
        <bk-title lang-code="receiveGiftCard_claim_failed"></bk-title>
        <bk-view class="view-tips">
          <bk-lang code="receiveGiftCard_claim_failed_tip1"/>
        </bk-view>
        <bk-button class="view-gotIt" lang-code="receiveGiftCard_got" @click="handleGotIt" />
      </bk-view>

      <bk-view class="view-container view-result" v-else-if="status==='CLAIMED'">
        <bk-image :src="$bk_getImageUrl('Def_Icon_E_Giftcard_Claim_Fail.png')"/>
        <bk-title lang-code="receiveGiftCard_claim_failed"></bk-title>
        <bk-view class="view-tips">
          <bk-lang code="receiveGiftCard_claim_failed_tip2"/>
        </bk-view>
        <bk-button class="view-gotIt" lang-code="receiveGiftCard_got" @click="handleGotIt" />
      </bk-view>

      <bk-view class="view-container view-result" v-else-if="dataList.length===0">
        <bk-image :src="$bk_getImageUrl('Def_Icon_E_Giftcard_Claim_Fail.png')"/>
        <bk-title>There is no send method available</bk-title>
        <bk-button class="view-gotIt" lang-code="receiveGiftCard_got" @click="handleGotIt" />
      </bk-view>

      <bk-view class="view-container" v-else>
        <bk-view class="view-method" v-if="dataList.length>0">
          <give-method :dataList="dataList" :must-flag="true" v-model:value="formData.deliveryMethods"/>
        </bk-view>

        <bk-view class="view-divide" v-if="dataList.length>0"></bk-view>

        <bk-view class="form-item" v-if="showEmail">
          <bk-view class="view-label">
            <span class="view-must">*</span>
            <bk-lang code="receiveGiftCard_email"></bk-lang>
          </bk-view>
          <bk-input width="100%" must-flag v-model:value="formData.recipientEmail"/>
        </bk-view>

        <bk-view class="form-item" v-if="showMobile">
          <bk-view class="view-label">
            <span class="view-must">*</span>
            <bk-lang code="receiveGiftCard_mobile"></bk-lang>
          </bk-view>
          <phoneInput
            lang-code_label="bkGiveAsGift_email"
            :dataList="dictInfo.intMobileCd"
            v-model="formData.recipientMobile"
            v-model:intMobileCd="formData.recipientMobileCdValue"
            v-model:intMobileCode="formData.recipientMobileCdCode"
          />
        </bk-view>

        <bk-view class="view-sendTip">
          <bk-lang code="receiveGiftCard_sendTip"/>
        </bk-view>

        <bk-view class="view-footer">
          <bk-button size="full" class="btn-cancel" lang-code="receiveGiftCard_send" @click="handelSend"></bk-button>
        </bk-view>
      </bk-view>

    </bk-view>
  </bk-page>
</template>

<script>

	import {baseReq, connectReq, customerReq, shopReq} from '@r';
	import GiveMethod from './giveMethod/giveMethod.vue';
	import phoneInput from '@/pages/login/signup/phoneInput/phoneInput.vue';
	import FingerprintJS from '@fingerprintjs/fingerprintjs';

	export default {
		name: 'receiveGiftCard',
		components: {phoneInput, GiveMethod},
		props: {},
		data () {
			return {
				formData: {
					deliveryMethods: [],
					recipientEmail: '',
					recipientMobile: '',
					recipientMobileCdValue: '',
					recipientMobileCdCode: '',
				},
				deviceId: '',
				dataList: [],
				dictInfo: {},
				errorLink: false,
				status: undefined,
				isReady: false,
			};
		},
		computed: {
			navBarInfo () {
				return {
					langCode_title: this.errorLink || this.status ? '' : 'receiveGiftCard_title',
				};
			},
			showEmail () {
				const {deliveryMethods = []} = this.formData;
				return deliveryMethods.includes('EMAIL');
			},
			showMobile () {
				const {deliveryMethods = []} = this.formData;
				return deliveryMethods.includes('SMS') || deliveryMethods.includes('WHATS_APP');
			}
		},
		watch: {},
		methods: {
			handleGotIt () {
				const {custId} = this.$route.query;
				const map = { // 有定制的url
					KISHAIR: 'https://kis-book.mase.cloud/home'
				};

				if (map[custId]) {
					return window.location.replace(map[custId]);
				}

				if (custId) {
					return window.location.replace(`https://clients.mase.cloud/selectStore?custId=${custId}`);
				}

				return window.location.replace('https://clients.mase.cloud/home');
			},
			async handelSend () {
				const {verifyCode, compId, goodsId} = this.$route.query;
				const {deviceId} = this;

				const {
					deliveryMethods = [],
					recipientEmail = '',
					recipientMobile = '',
					recipientMobileCdValue,
					recipientMobileCdCode,
				} = this.formData;

				const params = {
					compId, goodsId, deviceId,
					qrcodeIdentifier: verifyCode,
				};

				const methodType = deliveryMethods[0];
				if (methodType === 'EMAIL') {
					if (!recipientEmail) {
						this.$bk_message.error({langCode: 'receiveGiftCard_emailTip'});
						return;
					}
					if (!/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(recipientEmail)) {
						this.$bk_message.error({langCode: 'receiveGiftCard_emailTip_error'});
						return;
					}
					params['recipientEmail'] = recipientEmail;
					params['deliveryMethod'] = 'EMAIL';
				}
				if (methodType === 'SMS' || methodType === 'WHATS_APP') {
					if (!recipientMobile) {
						this.$bk_message.error({langCode: 'receiveGiftCard_mobileTip'});
						return;
					}
					const res = await baseReq.requestGetMobileIsValid(this, {
						mobile: recipientMobile,
						regionCode: recipientMobileCdValue,
					});
					if (!res || res.isValid === false) {
						this.$bk_message.error({langCode: 'receiveGiftCard_mobileTip_error'});
						return;
					}

					params['deliveryMethod'] = methodType;
					params['recipientMobile'] = recipientMobile;
					params['recipientMobileCdValue'] = recipientMobileCdValue;
					params['recipientMobileCdCode'] = recipientMobileCdCode;
				}
				customerReq.claimGiftCardByQrCode(this, params).then((res) => {
					if (res) {
						this.status = res;
						this.$router.replace({
							name: 'ReceiveGiftCard',
							query: {...this.$route.query, status: res}
						});
					}
				});
			},

			// 校验二维码链接有效性
			async requestGetQrCodeUrlIsValid () {
				const {verifyCode, compId} = this.$route.query;
				const {deviceId} = this;
				const res = await customerReq.requestGetQrCodeUrlIsValid(this, verifyCode, compId, deviceId).catch(() => {
					this.isReady = true;
				});
				if (!res) {
					this.errorLink = true;
				} else {
					if (res === 'SUCCESS') {
						await this.requestPostDictByTypeCode();
					} else {
						this.status = res;
					}
				}
				this.isReady = true;
			},

			async requestPostDictByTypeCode () {
				const {compId} = this.$route.query;

				const resDict = await baseReq.requestPostDictByTypeCode(this, ['intMobileCd'], true);

				if (compId) {
					const resShop = await shopReq.requestGetShopDetailByCompId(this, compId);
					const mobileCdCode = resShop?.countryCode?.toUpperCase() || 'CN';
					this.formData.recipientMobileCdValue = resDict.intMobileCd.find((v) => {
						return v.code === mobileCdCode;
					})?.value || '+86';
					this.formData.recipientMobileCdCode = mobileCdCode;
				} else {
					this.formData.recipientMobileCdCode = 'CN';
					this.formData.recipientMobileCdValue = '+86';
				}
				this.dictInfo = resDict;
			},

			async requestGetSendMethod () {
				const {compId, custId} = this.$route.query;

				const res = await		connectReq.checkMessageSendAvailable(this, {
					compId,
					custId,
					messageType: 'GIFT_CARD_NOTIFICCATION'
				}).catch(() => {
					this.isReady = true;
				});
				const list = [];
				if (res?.['email']) {
					list.push({
						langCode: 'receiveGiftCard_by_email',
						key: 'EMAIL',
						checked: false,
						src: 'https://static-global.boka.vc/mase/def/Def_Icon_GiveAsGift_Email.png'
					});
				}
				if (res?.['sms']) {
					list.push({
						langCode: 'receiveGiftCard_by_sms',
						key: 'SMS',
						checked: false,
						src: 'https://static-global.boka.vc/mase/def/Def_Icon_GiveAsGift_Sms.png'
					});
				}
				if (res?.['whatsapp']) {
					list.push({
						langCode: 'receiveGiftCard_by_whatsApp',
						key: 'WHATS_APP',
						checked: false,
						src: 'https://static-global.boka.vc/mase/def/Def_Icon_GiveAsGift_WhatsApp.png'
					});
				}
				this.dataList = list;
			},

			async getDeviceId () {
				const fpPromise = FingerprintJS.load();
				const fp = await fpPromise;
				const result = await fp.get();
				this.deviceId = result.visitorId;
			}
		},
		async mounted () {
			const {verifyCode, compId, goodsId, status} = this.$route.query;
			if (!verifyCode || !compId || !goodsId) {
				this.errorLink = true;
				return;
			}
			const statusMap = {
				SUCCESS: 'SUCCESS',
				CLAIMED: 'CLAIMED',
				EXPIRED: 'EXPIRED',
			};
			if (status && statusMap[status.toUpperCase()]) {
				this.status = statusMap[status.toUpperCase()];
				return;
			}
			await this.getDeviceId();
			await this.requestGetSendMethod();
			await this.requestGetQrCodeUrlIsValid();

		}
	};
</script>

<style scoped lang="less">
@import './receiveGiftCard.less';
</style>